"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/ScheduleTab/ScheduleSection/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');







var _team = require('shared/selectors/team');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _time = require('shared/services/time');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');

var _components = require('web/screens/Directory/components');
var _EditScheduleModal = require('./EditScheduleModal'); var _EditScheduleModal2 = _interopRequireDefault(_EditScheduleModal);
var _utils = require('./utils');






// The business hours row, open: the time zone, the week, and Edit hours.
const ScheduleSection = ({ onUpdateInfo, teamKey }) => {
  const autoReplyTimeZone = _hooks.useAppSelector.call(void 0, 
    state => _nullishCoalesce(_optionalChain([_team.selectTeamByKey.call(void 0, state, teamKey), 'optionalAccess', _ => _.AutoReplyTimeZone]), () => ( null)),
  )
  const teamHoursList =
    _hooks.useAppSelector.call(void 0, state => _team.selectTeamHoursList.call(void 0, state, teamKey), _reactredux.shallowEqual)
  const areTeamHoursSet = _hooks.useAppSelector.call(void 0, state => _team.selectAreTeamHoursSet.call(void 0, state, teamKey))

  const {
    isOpen: isEditModalOpen,
    onOpen: onOpenEditModal,
    onClose: onCloseEditModal,
  } = _useToggle2.default.call(void 0, )

  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const handleSubmit = _react.useCallback.call(void 0, 
    (data) => onUpdateInfo(data)
      .then(onCloseEditModal)
      .then(() => showSuccessBar('Successfully updated hours'))
      .catch(() => showWarningBar('Failed to update hours')),
    [onUpdateInfo, onCloseEditModal, showSuccessBar, showWarningBar],
  )

  return (
    _react2.default.createElement('div', { className: "team-page--hours", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
      , _react2.default.createElement('div', { className: "team-page--hours--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        , _react2.default.createElement('span', { className: autoReplyTimeZone ? 'team-page--hours--tz' : 'team-page--muted', __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
          ,  autoReplyTimeZone ? _time.timezoneNames[autoReplyTimeZone] : 'No time zone set' 
        )
        , _react2.default.createElement(_components.InfoBtn, {
          label: "Edit hours" ,
          onClick: onOpenEditModal,
          iconSrc: "/assets/icons/icon-edit-purple.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
        )
      )
      ,  areTeamHoursSet ? (
        _react2.default.createElement('ul', { className: "team-page--hours--week", 'aria-label': "Business hours" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          ,  _utils.weekFromMonday.map(day => (
            _react2.default.createElement('li', {
              key: day,
              className: _classBuilder2.default.call(void 0, 'team-page--hours--day', !teamHoursList[day] && 'team-page--hours--day--closed'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}

              , _react2.default.createElement('span', { className: "team-page--hours--day-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}},  _utils.shortDayNames[day] )
              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 70}},  _utils.dayHours.call(void 0, teamHoursList[day]) )
            )
          ))
        )
      ) : (
        _react2.default.createElement('div', { className: "team-page--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}, "No hours set"  )
      )
      , _react2.default.createElement(_EditScheduleModal2.default, {
        isOpen: isEditModalOpen,
        onClose: onCloseEditModal,
        teamKey: teamKey,
        onSubmit: handleSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ScheduleSection)
